import { KEY_MAX_LENGTH } from '@gonfalon/strings/patterns';

export const MAX_PROJECT_KEY_LENGTH = KEY_MAX_LENGTH;
export const MAX_PROJECT_NAME_LENGTH = 256;
